import React from 'react';
import { TrendingDown } from 'lucide-react';
import { Container, Eyebrow, H2, Reveal } from './shared';

const POSITIONS = [
  { name: 'Hype-Aktie vom TikTok-Tipp', value: '−41,2 %' },
  { name: 'Tipp vom Kollegen', value: '−23,8 %' },
  { name: 'Im Crash panisch verkauft', value: '−18,5 %' },
  { name: 'Zu teuer gekauft', value: '−12,1 %' },
];

const MISTAKES = [
  'Kaufen, weil gerade alle darüber reden',
  'Kein Plan, wann gekauft oder verkauft wird',
  'Nicht wissen, was ein Unternehmen wirklich wert ist',
];

const RedChart = () => (
  <svg viewBox="0 0 320 110" className="h-28 w-full" aria-hidden="true">
    <defs>
      <linearGradient id="redfill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#FF6B6B" stopOpacity="0.35" />
        <stop offset="1" stopColor="#FF6B6B" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path d="M0 18 L30 26 L55 20 L80 38 L105 34 L130 52 L150 47 L175 64 L200 58 L225 76 L250 72 L275 88 L300 84 L320 98 L320 110 L0 110 Z" fill="url(#redfill)" />
    <path className="chart-draw" d="M0 18 L30 26 L55 20 L80 38 L105 34 L130 52 L150 47 L175 64 L200 58 L225 76 L250 72 L275 88 L300 84 L320 98" fill="none" stroke="#FF6B6B" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
);

export const Mistakes = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="mistakes-section">
    <Container className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <Eyebrow>Was die meisten falsch machen</Eyebrow>
        <H2>Siehst du dich darin wieder?</H2>
        <ul className="mt-8 space-y-4">
          {MISTAKES.map((m) => (
            <li key={m} className="flex gap-3 text-base leading-relaxed text-ink">
              <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-nope/15 text-sm font-bold text-nope" aria-hidden="true">✕</span>
              {m}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={100}>
        <div className="rounded-[24px] border border-nope/25 bg-navy p-6 shadow-[0_0_60px_rgba(255,107,107,0.10)] sm:p-7" data-testid="negative-depot-card">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs uppercase tracking-[0.14em] text-ink">Typisches Depot ohne Plan</p>
              <p className="mt-2 font-display text-4xl font-bold text-nope">−27,4 %</p>
            </div>
            <span className="grid h-11 w-11 place-items-center rounded-full bg-nope/15 text-nope"><TrendingDown size={22} aria-hidden="true" /></span>
          </div>
          <div className="mt-4"><RedChart /></div>
          <ul className="mt-4 divide-y divide-white/5">
            {POSITIONS.map((p) => (
              <li key={p.name} className="flex items-center justify-between gap-4 py-3 text-sm">
                <span className="text-white/85">{p.name}</span>
                <span className="font-semibold text-nope">{p.value}</span>
              </li>
            ))}
          </ul>
          <p className="mt-4 text-[11px] text-ink/70">Beispielhafte Darstellung</p>
        </div>
      </Reveal>
    </Container>
  </section>
);
